export default {
  namespaced: true,
  state: {
    solved: "", //해결여부
    satisfaction: "" //만족도
  },
  mutations: {
    setSolved(state, solved) {
      state.solved = solved;
    },
    setSatisfaction(state, satisfaction) {
      state.satisfaction = satisfaction;
    }
  },
  actions: {},
  getters: {
    getSolved(state) {
      return state.solved;
    },
    getSatisfaction(state) {
      return state.satisfaction;
    }
  }
};
